import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import {
  EditableSelect,
  Autocomplete,
  Modal,
} from '../../components';

import uiStyles from '../../styles/ui.scss';
import styles from './CaseCloseModal.scss';

const mapStateToProps = state => {
  return {
    currentCompany: state.currentCompany,
    currentRoom: state.currentRoom,
    reasonTypes: state.reasonTypes,
  };
};

@connect(mapStateToProps)
export class CaseCloseModal extends Component {

  state = {
    caseReasonType: null,
    caseStateOption: false,
    autocompleteOptions: []
  };

  componentDidMount(){
    const { reasonTypes } = this.props;

    this.setState({
      caseReasonType: reasonTypes[0]?.id || null,
      autocompleteOptions: this.reasonSelectOptions
    });
  }

  componentDidUpdate(prevProps){
    const { reasonTypes } = this.props;
    if (reasonTypes !== prevProps.reasonTypes) {
      this.setState({
        caseReasonType: reasonTypes[0]?.id || null
      });
    }
  }

  setSelectedValue = (type, value) => {
    this.setState({ [type]: value });
  };

  onChangeCaseButtonClick = () => {
    const { onSubmit } = this.props;
    const {
      caseReasonType,
      caseStateOption
    } = this.state;

    onSubmit({
      caseReasonType,
      caseStateOption
    });
  };

  getReasonSelectOptions = () => {
    const { reasonTypes } = this.props;
    return reasonTypes.map(type => {
      return {
        value: type.id,
        title: type.title,
      }
    });
  };

  onTaskCommentChange = (e) => {
    this.setState({ taskComment: e.target.value });
  };

  onAutocompleteType(query){
    let autocompleteOptions = this.reasonSelectOptions.filter(el => el.title.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
    autocompleteOptions = autocompleteOptions.length ? autocompleteOptions : this.reasonSelectOptions;
    this.setState({ autocompleteOptions });
  };

  onAutocompleteSelect = (caseReasonType) => {
    this.setState({ caseReasonType });
    this.setState({ autocompleteOptions: this.reasonSelectOptions });
  };


  reasonSelectOptions = this.getReasonSelectOptions();

  render(){
    const { className, onClose } = this.props;
    const {
      caseReasonType,
      caseStateOption,
      autocompleteOptions
    } = this.state;

    return (
      <Modal className={className} onClose={onClose} title="Завершение кейса" verticallyCentered={true}>
        <strong className={cn(styles.title)}>Тема обращения</strong>

        <Autocomplete
          items={autocompleteOptions}
          placeholder="Не выбрано"
          onSelect={this.onAutocompleteSelect}
          showEmpty={true}
          onType={caseReasonType => {
            this.setState({ caseReasonType });
            this.onAutocompleteType(caseReasonType)
          }}
          overrideClassNames={{
            list: styles.autocompleteList,
            container: styles.autocompleteContainter
          }}
        />

        <div className={styles.taskSettings}>
          <EditableSelect
            onChange={({value}) => this.setSelectedValue('caseStateOption', value)}
            defaultValue={caseStateOption}
            options={[
              {
                value: true,
                title: 'Вопрос решен',
              },
              {
                value: false,
                title: 'Вопрос не решен',
              }
            ]}
          />
        </div>
        <div className={cn(styles.btnGroup)}>

          <button
            className={cn(uiStyles.buttonPrimary, !caseReasonType?.value ? uiStyles.light : '')}
            disabled={!caseReasonType?.value}
            onClick={this.onChangeCaseButtonClick}
          >
            Завершить кейс
          </button>
          <button
            className={cn(uiStyles.buttonSecondary)}
            onClick={onClose}
          >
            Отмена
          </button>
        </div>
      </Modal>
    );
  }
}
